import request from '../request';
import cache from '../cache';
import getDefer from '../getDefer';
// 初始化，会缓存结果，并且失败后不重试
export default {
    init: cache(async function wxInit(isDebug = false) {
        if (!wx) {
            throw new Error('需引入sdk文件');
        }
        const defer = getDefer();
        const data = await request.post('/rest/n/kmovie/wx/gzh/js/kyjj/getSignature', {
            url: window.location.href,
        });
        wx.ready(() => {
            defer.resolve();
        });
        wx.error((err) => {
            defer.reject(err);
        });
        if (data.result === 1) {
            wx.config({
                debug: isDebug,
                appId: 'wx47066ee756824c62',
                timestamp: data.timestamp,
                nonceStr: data.noncestr,
                signature: data.signature,
                jsApiList: [
                    'updateTimelineShareData',
                    'updateAppMessageShareData', // 分享给朋友、分享到QQ
                ],
                openTagList: ['wx-open-launch-app'],
            });
        }
        else {
            throw new Error('微信初始化失败');
        }
        return defer.promise;
    }, null, { resetReject: false }),
    async setShareConfig(share) {
        await this.init();
        wx.updateAppMessageShareData({
            title: share?.title || '快影',
            desc: share?.desc || '给你分享了一个好玩的模板，快来体验！',
            link: share?.link || window.location.href,
            imgUrl: share?.imgUrl ||
                'https://static.yximgs.com/udata/pkg/kuaiying-frontend-cdn/kuaiying-frontend-csr/kuaiying.ico',
            success: () => {
                console.log('微信分享设置成功');
            },
            error: () => {
                console.log('微信分享设置失败');
            },
        });
    },
};
